export default [
    {
        path: '/performance-goals',
        name: 'indexPerformanceGoals',
        meta: { title: 'indexPerformanceGoals' },
        component: () => import('@/pages/admin/performance-goals/index.vue'),
    },
    {
        path: "/performance-goals/create",
        name: "createPerformanceGoals",
        meta: { title: 'createPerformanceGoals' },
        component: () => import('@/pages/admin/performance-goals/create.vue'),
    },
    {
        path: "/performance-goals/:id/edit",
        name: "editPerformanceGoals",
        meta: { title: 'editPerformanceGoals' },
        component: () => import('@/pages/admin/performance-goals/edit.vue'),
    },
]